import { BATCH_SHIPMENT_FAILURE, BATCH_SHIPMENT_REQUEST, BATCH_SHIPMENT_RESET, BATCH_SHIPMENT_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const batchShipmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case BATCH_SHIPMENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case BATCH_SHIPMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case BATCH_SHIPMENT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case BATCH_SHIPMENT_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: null });
        default:
            return state;
    }
};
export default batchShipmentReducer;
